import { useEffect, useState } from "react";

const isCordova = typeof window.cordova !== "undefined";

export default function usePhoneContacts() {
  const [phoneContacts, setPhoneContacts] = useState([]);

  useEffect(() => {
    if (!isCordova || !navigator.contacts) return;

    const fields = ['emails'];

    navigator.contacts.find(fields, (contacts) => {
      const formatted = contacts
        .map((c, index) => ({
          id: index,
          email: c.emails?.[0]?.value || "",
        }))
        .filter(c => c.email); // on garde seulement ceux avec un email

      setPhoneContacts(formatted);
    }, (err) => {
      console.error("Erreur récupération contacts :", err);
    });

  }, []);

  return phoneContacts;
}